import { defineComponent as _defineComponent } from 'vue'
import { computed, toRefs, type DefineComponent } from 'vue';

export interface Props {
    tag?: string | DefineComponent,
    canonical?: boolean;
    absolute?: boolean;
    withBase?: boolean;
    to?: string,
    href?: string,
    external?: boolean,
    target?: '_blank' | '_parent' | '_self' | '_top' | (string & {}) | null,
    rel?: 'noopener' | 'noreferrer' | 'nofollow' | 'sponsored' | 'ugc' | (string & {}) | null,
    noRel?: boolean,
    prefetchedClass?: string,
    prefetch?: boolean,
    theme?: 'light' | 'dark',
    disabled?: boolean,
    disabledWithIndividualOpacity?: boolean,
    hoverBackground?: string,
    active?: boolean,
}
export default /*#__PURE__*/_defineComponent({
  __name: 'Menu',
  props: {
    tag: { default: 'NuxtLink' },
    canonical: { type: Boolean },
    absolute: { type: Boolean },
    withBase: { type: Boolean },
    to: null,
    href: null,
    external: { type: Boolean },
    target: null,
    rel: null,
    noRel: { type: Boolean },
    prefetchedClass: null,
    prefetch: { type: Boolean },
    theme: null,
    disabled: { type: Boolean },
    disabledWithIndividualOpacity: { type: Boolean },
    hoverBackground: { default: 'var(--neutral-surface-subtle)' },
    active: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { tag: string | DefineComponent, canonical?: boolean, absolute?: boolean, withBase?: boolean, to?: string, href?: string, external?: boolean, target?: '_blank' | '_parent' | '_self' | '_top' | (string & {}) | null, rel?: 'noopener' | 'noreferrer' | 'nofollow' | 'sponsored' | 'ugc' | (string & {}) | null, noRel?: boolean, prefetchedClass?: string, prefetch?: boolean, theme?: 'light' | 'dark', disabled?: boolean, disabledWithIndividualOpacity?: boolean, hoverBackground: string, active?: boolean };

;



const {
    theme,
    tag,
    active,
    external,
    target,
    rel,
    noRel,
    prefetchedClass,
    prefetch,
    canonical,
    absolute,
    withBase,
    hoverBackground,
    disabled,
    disabledWithIndividualOpacity,
} = toRefs(props);

const isAnyhowDisabled = computed(() => disabled.value || disabledWithIndividualOpacity.value);

return { __sfc: true,props, theme, tag, active, external, target, rel, noRel, prefetchedClass, prefetch, canonical, absolute, withBase, hoverBackground, disabled, disabledWithIndividualOpacity, isAnyhowDisabled }
}

})